/*eslint-disable */

import {
  FETCH_GLOBAL_SETTINGS_REQUEST,
  FETCH_GLOBAL_SETTINGS_SUCCESS,
  FETCH_GLOBAL_SETTINGS_FAILURE,
} from '../actionTypes';

const initialState = {
  loading: true,
  data: {},
  error: null,
};

const globalSettingsReducer = (state = initialState, action: any): any => {
  switch (action.type) {
    case FETCH_GLOBAL_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_GLOBAL_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_GLOBAL_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        data: {},
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default globalSettingsReducer;
